import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LoginForm from './LoginForm';

function LoginPage({
  role,
  isAuthenticated,
  setHeaderType,
  setIsAuthenticated,
}) {
  return (
    <Container className='login-container'>
      <Row>
        <Col
          md={{ span: 5, offset: 1 }}
          className='d-flex flex-column justify-content-center mb-3 mb-md-0'
        >
          {role === 'admin' ? (
            <div>
              <h2>Administrera Folkrace</h2>
              <ul>
                <li>Skapa och hantera arrangörer</li>
                <li>Skapa och hantera administratörer</li>
              </ul>
            </div>
          ) : (
            <div>
              <h2>Folkrace</h2>
              <ul>
                <li>Skapa och hantera tävlingar</li>
                <li>Hantera anmälningar</li>
                <li>Exportera deltagarlistor</li>
                <li>Administrera anbud</li>
              </ul>
            </div>
          )}
        </Col>
        <Col
          md={6}
          className='d-flex justify-content-center justify-content-md-start'
        >
          <LoginForm
            role={role}
            setHeaderType={setHeaderType}
            setIsAuthenticated={setIsAuthenticated}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default LoginPage;
